import React from "react";

const Info = ({
  className,
  role,
  ignoreDefaultSize,
  width = 16,
  height = 16,
  onClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ignoreDefaultSize ? undefined : width}
      height={ignoreDefaultSize ? undefined : height}
      viewBox="0 0 20 20"
      fill="none"
      role={role}
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10 9C10.5523 9 11 9.44772 11 10V13.5996C11 14.1519 10.5523 14.5996 10 14.5996C9.44772 14.5996 9 14.1519 9 13.5996V10C9 9.44772 9.44772 9 10 9ZM10.0088 5.40039C10.5611 5.40039 11.0088 5.84811 11.0088 6.40039C11.0085 6.95245 10.5609 7.40039 10.0088 7.40039H10C9.44788 7.40039 9.00026 6.95245 9 6.40039C9 5.84811 9.44772 5.40039 10 5.40039H10.0088Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default React.memo(Info);
